export const api = "/api/v1"
export const scale = 0.75
// export const scale = 1